/**
 * AA Callback Page Route
 *
 * Handles the redirect callback from Saafe after the AA consent flow.
 * Uses the AACallbackHandler component to display appropriate UI.
 *
 * Route: /aa/callback
 *
 * Expected URL params from Saafe:
 * - Success: ?aa_status=success&linked_accounts=3
 * - Error: ?aa_status=error&aa_error=message&aa_error_code=CODE
 */

import { createFileRoute } from "@tanstack/react-router";
import { AACallbackHandler } from "@/components/aa";
import { GlobalErrorFallback } from "@/components/error";

export const Route = createFileRoute("/aa/callback")({
  component: AACallbackPage,
  errorComponent: GlobalErrorFallback,
});

function AACallbackPage() {
  return (
    <AACallbackHandler
      retryPath="/aa"
      autoNavigate
      autoNavigateDelay={3000}
    />
  );
}
